import type { ComponentProps, ReactElement } from "react";
import { Input } from "./Input";
import type { InputSize } from "./Input.types";

export type CustomInputProps = Omit<ComponentProps<"input">, "size" | "ref">;
export type CustomInputComponent = (props: CustomInputProps) => ReactElement;

const createCustomInput = (size: InputSize): CustomInputComponent =>
    function SizedInput({ "aria-invalid": ariaInvalid, ...props }) {
        return (
            <Input
                {...props}
                variant="primary"
                size={size}
                invalid={ariaInvalid === true || ariaInvalid === "true"}
            />
        );
    };

/**
 * Stable per-size `Input` wrappers for react-number-format's `customInput`.
 * The component identity must not change between renders, otherwise the
 * library remounts the input and drops focus and caret position, so callers
 * build the map once at module level and pick by size at render time.
 * `aria-invalid` from the caller drives the Input's `invalid` chrome.
 */
export const createCustomInputsBySize = (): Record<
    InputSize,
    CustomInputComponent
> => ({
    md: createCustomInput("md"),
    lg: createCustomInput("lg"),
    xl: createCustomInput("xl"),
});
